<template>
    <li class="nav-item dropdown">
        <a id="navbarCart" class="nav-link dropdown-toggle" href="#">
            {{ t.cart.cart }} <i class="fas fa-shopping-bag fa-fw"></i>
            <span class="badge rounded-pill bg-primary">{{ cart.total_qty }}</span>
        </a>
        <ul id="cart" class="dropdown-menu dropdown-menu-end shadow py-0 m-0" aria-labelledby="navbarCart">
            <div class="p-3">
                <div v-if="loaded && !cart.products.length">
                    {{ t.cart.empty_cart }}
                </div>
                <div v-else-if="loaded">
                    <transition-group name="fade">
                        <div class="row mb-3" v-for="product in cart.products" :key="product.index">
                            <div class="col-4">
                                <a :href="product.url">
                                    <img :src="product.thumbnail" alt="" class="img-fluid">
                                </a>
                            </div>
                            <div class="col p-0 d-flex align-items-center">
                                <div>
                                    <div class="h5 fw-bold mb-2"><a :href="product.url">{{product.name}}</a></div>
                                    <div class="mb-2" v-if="product.product_variation_attributes">
                                        <div v-for="(prod_var_attr, index) in product.product_variation_attributes" :key="index"><b>{{prod_var_attr.attribute.name}}</b>: {{prod_var_attr.value.name}}</div>
                                    </div>
                                    <div v-else v-html="truncateText(product.description, 20)" class="mb-2"></div>
                                    <div class="row align-items-center">
                                        <div class="col-7">
                                            <div class="input-group">
                                                <span class="input-group-prepend"><button @click="product.qty--; updateProduct(product)" type="button" class="btn btn-light border">-</button></span>
                                                <input type="text"  @focus="$event.target.select()" class="form-control text-center" v-model.number="product.qty" @change="updateProduct(product)">
                                                <span class="input-group-prepend"><button @click="product.qty++; updateProduct(product)" type="button" class="btn btn-light border">+</button></span>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="fw-bold">{{ amountWithCurrency(product.total) }}</div>
                                        </div>
                                    </div>
                                    <div v-if="product.is_gift" class="text-secondary">(+{{amountWithCurrency(settings.gift_price*product.qty)}} {{ t.cart.gift_cost }})</div>
                                </div>
                            </div>
                            <div class="col-1 align-self-center text-center text-secondary"><i class="fas fa-trash cursor-pointer" @click="deleteProduct(product)"></i></div>
                        </div>
                    </transition-group>
                    <transition name="fade">
                        <div v-if="cart.total" class="text-end fw-bold border-top py-3 text-uppercase">{{ t.cart.total }} {{amountWithCurrency(cart.subtotal)}}</div>
                    </transition>
                </div>
            </div>
            <transition name="fade">
                <div v-if="loaded && cart.products.length" class="d-flex border-top">
                    <a :href="url('cart')" class="btn btn-light col">{{ t.cart.view_cart }}</a>
                    <a :href="url('checkout')" class="btn btn-primary col">{{ t.cart.checkout }}</a>
                </div>
            </transition>
        </ul>
    </li>
</template>

<script>
import store from '../CartStore'
    export default {
        store: store,
        data() {
            return {
                settings: window.settings,
                config: window.config,
                locale: window.locale,
                t: window.t,
            }
        },
        mounted() {
            this.$store.dispatch('getCart')
        },
        computed: {
            ...Vuex.mapGetters(['loaded', 'cart']),
        },
        methods: {
            ...Vuex.mapActions(['deleteProduct', 'updateProduct']),
        }
    }
</script>
